// src/api/shifts.js
import { apiRequest } from './index';

export const shiftsAPI = {
  getAll: () => apiRequest("/shifts"),

  getMyShifts: () => apiRequest("/shifts/my"),

  create: (shiftData) =>
    apiRequest("/shifts", {
      method: "POST",
      body: shiftData,
    }),

  update: (shiftId, updates) =>
    apiRequest(`/shifts/${shiftId}`, {
      method: "PUT",
      body: updates,
    }),

  updateComment: (shiftId, comment) =>
    apiRequest(`/shifts/${shiftId}/comment`, {
      method: "PUT",
      body: { comment },
    }),

  delete: (shiftId) =>
    apiRequest(`/shifts/${shiftId}`, { method: "DELETE" }),
    
  getConflicts: () => apiRequest("/shift-conflicts"),

  getByDateRange: (startDate, endDate) =>
    apiRequest(`/shifts?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`),

  batch: (operations) =>
    apiRequest("/shifts/batch", {
      method: "POST",
      body: { operations },
    }),
};
